import React from "react";
import {
  Heart,
  Cart,
  BarChart,
  Building,
  Bank,
  Cpu,
  Hospital,
} from "react-bootstrap-icons";

const sectors = [
  { icon: <Heart />, text: "Healthcare Innovation" },
  { icon: <Cart />, text: "Retail Transformation" },
  { icon: <BarChart />, text: "Manufacturing Optimization" },
  { icon: <Building />, text: "Hospitality Management" },
  { icon: <Bank />, text: "Financial Services" },
  { icon: <Hospital />, text: "Public Sector Modernization" },
  { icon: <Cpu />, text: "Technology Innovation" },
];

export default function Sectors() {
  return (
    <section className="py-5 text-center">
      <div className="container">
        <span className="pill-badge mb-3">Industry Expertise</span>
        <h2 className="fw-bold mb-3">Sectors We Serve</h2>
        <p className="text-muted mb-4">
          We serve dynamic sectors requiring sophisticated technological solutions
        </p>

        <div className="d-flex flex-wrap justify-content-center gap-3">
          {sectors.map((s, i) => (
            <div key={i} className="sector-pill">
              {s.icon}
              <span>{s.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
